import { isDev } from '@/utils/system'

export class LoggerService {
  public log(message?: string): void {
    if (!message) return

    if (isDev()) {
      // eslint-disable-next-line no-console
      console.log(message)
    }
  }

  public logError(errorMessage?: string): void {
    if (!errorMessage) return

    if (isDev()) {
      // eslint-disable-next-line no-console
      console.error(errorMessage)
    }
  }
}

export default new LoggerService()
